class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility('#cart-icon-bubble');
    this.setHeaderCartIconAccessibility('#cart-icon-bubble1');
  }

  setHeaderCartIconAccessibility(idElement) {
    const cartLink = document.querySelector(idElement);
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    // CACO: Ocultar Shopify Inbox cuando el carrito se abre
    this._hideChatWidget();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    // CACO: Restaurar Shopify Inbox cuando el carrito se cierra
    this._showChatWidget();
  }

  _hideChatWidget() {
    // Metodo 1: API oficial de Shopify Inbox
    if (window.ShopifyChat && typeof window.ShopifyChat.hide === 'function') {
      window.ShopifyChat.hide();
      return;
    }
    // Metodo 2: Esperar a que cargue la API
    const waitForChat = setInterval(() => {
      if (window.ShopifyChat && typeof window.ShopifyChat.hide === 'function') {
        window.ShopifyChat.hide();
        clearInterval(waitForChat);
      }
    }, 100);
    // Fallback: ocultar el contenedor directamente
    setTimeout(() => {
      clearInterval(waitForChat);
      const chatContainer = document.getElementById('shopify-chat-sharing-iframe-container');
      if (chatContainer) chatContainer.style.setProperty('display', 'none', 'important');
    }, 2000);
  }

  _showChatWidget() {
    // Metodo 1: API oficial de Shopify Inbox
    if (window.ShopifyChat && typeof window.ShopifyChat.show === 'function') {
      window.ShopifyChat.show();
      return;
    }
    // Fallback: restaurar visibilidad del contenedor directamente
    const chatContainer = document.getElementById('shopify-chat-sharing-iframe-container');
    if (chatContainer) chatContainer.style.removeProperty('display');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      const hasItems = this.querySelectorAll('tr[id^="CartDrawer-Item-"]:not(.scd-protection-item), .scd-bundle-card-row').length > 0;
      this.classList.toggle('is-empty', !hasItems);
      const inner = this.querySelector('.drawer__inner');
      if (inner) inner.classList.toggle('is-empty', !hasItems);

      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      // Re-init recommendations after the full drawer HTML has been replaced
      if (typeof window.initDrawerRecommendations === 'function') {
        window.initDrawerRecommendations();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'cart-icon-bubble1',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends (customElements.get('cart-items') || window.CartItems) {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble1',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// CACO: Auto-open cart if 'open_cart=true' is in URL
document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open_cart') === 'true') {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Delay slightly to ensure fonts/styles are ready for a smooth animation
      setTimeout(() => {
        cartDrawer.open();
        // Clean up URL without refreshing to prevent re-opening
        const newUrl = window.location.pathname + window.location.search.replace(/[?&]open_cart=true/, '').replace(/^&/, '?');
        window.history.replaceState({}, '', newUrl);
      }, 500);
    }
  }
});
